module.exports = __webpack_public_path__ + "img/repair-4.4c86f66e.jpg";